module.exports = __webpack_public_path__ + "img/am6.65fcd7ac.png";